<script>
  export let size = 18;
  export let highlight = false;
  export let baseColor = "#8c8c8c";
  export let highlightColor = "#0091d9";

  $: fillColor = highlight ? highlightColor : baseColor;
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M19.075 4.925C17.25 3.125 14.75 2 12 2C9.25 2 6.75 3.125 4.925 4.925C3.125 6.75 2 9.25 2 12C2 17.525 6.475 22 12 22C14.75 22 17.25 20.875 19.075 19.075C20.875 17.25 22 14.75 22 12C22 9.25 20.875 6.75 19.075 4.925ZM13 17.1C13 17.65 12.55 18.1 12 18.1C11.45 18.1 11 17.65 11 17.1V10.3C11 9.75 11.45 9.3 12 9.3C12.55 9.3 13 9.75 13 10.3V17.1ZM13 7.1C13 7.65 12.55 8.1 12 8.1C11.45 8.1 11 7.65 11 7.1V6.9C11 6.35 11.45 5.9 12 5.9C12.55 5.9 13 6.35 13 6.9V7.1Z"
    fill={fillColor}
  ></path>
</svg>
